import React from 'react';
import { useRouteMatch, generatePath } from 'react-router-dom';

import styles from './LeaderBoard.module.less';
import Header from '../../components/Header';
import Icon from '../../components/Icon';
import Button from '../../components/Button';
import GameLink from '../../components/GameLink';

export default ({ tag, ranks = [] }) => {
  const { path } = useRouteMatch();

  return (
    <ul className={styles.LeaderBoard}>
      {ranks.map((rank, index) => {
        let source = `${tag}||${rank.code || ''}`;
        let to = { url: generatePath(path, { code: rank.code }) };

        return (
          <li key={index}>
            <Header
              title={rank.name || rank.desc}
              operate="2"
              to={to}
              source={source} />
            <nav>
              {rank.apps.slice(0, 5).map((app, subIndex) => {
                let id = app.softID || '';
                if (app.androidType === '1') {
                  id = app.packageName;
                }

                return (
                  <GameLink
                    key={subIndex}
                    info={{
                      targetType: '1',
                      appInfo: app,
                    }}
                    source={source}
                    logInfo={{
                      category: 'C',
                      action: 'Game_Non_Button',
                      params: {
                        id,
                        type: 'soft',
                        source,
                      },
                      bizInfo: app.bizInfo,
                    }}
                  >
                    <Icon app={app} />
                    <div>
                      <h1 title={app.softName}>{app.softName}</h1>
                      <p>{app.downloadCount || '1万次'}安装</p>
                      <Button
                        soft={app}
                        className="btn"
                        logInfo={{source}} />
                    </div>
                  </GameLink>
                );
              })}
            </nav>
          </li>
        );
      })}
    </ul>
  );
};
